import { Button, Form, Card, Row, Col, FormCheck } from "react-bootstrap";
import React, { useState, ChangeEvent, useEffect } from "react";
import GallerySelector from "./GallerySelector";
import { GalleryItem } from "../types/GalleryItem";
import { IGallery } from "../types/Gallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-datepicker/dist/react-datepicker.css";
import ProductItem from "./ProductItem";
import ImageItem from "./ImageItem";
import FileItem from "./FileItem";

const Gallery = (props: any) => {
    const handleGalleryChange = props.handleChange;
    const handleIsValid = props.handleIsValid;
    const gallery: IGallery = props.gallery;
    const shown: boolean = props.show;
    const [show, setShow] = useState(false);
    const [name, setName] = useState('');
    const [internalOnly, setInternalOnly] = useState(false);
    const [description, setDescription] = useState('');
    const [displayOrder, setDisplayOrder] = useState<number>();
    const [items, setItems]: [GalleryItem[] | undefined, Function] = useState();
    const changedItems = (i: GalleryItem[], selectAll = false) => {
        return [...i].map(item => {
            const changed = { ...item };
            changed.startDate = changed.startDate ? new Date(changed.startDate) : null
            changed.endDate = changed.endDate ? new Date(changed.endDate) : null
            if (changed.product) {
                const product = { ...changed.product };
                (product as any).startDate = changed?.product?.startDate ? new Date(changed?.product?.startDate) : null;
                (product as any).endDate = changed?.product?.endDate ? new Date(changed?.product?.endDate) : null;
                changed.product = product;
            }
            if (selectAll) {
                changed.selected = true;
            }
            return changed;
        });
    }
    useEffect(() => {
        if (gallery) {
            const i = gallery?.items || [];
            const is = changedItems(i, true);
            const iName = gallery.name || '';
            const iDesc = gallery.description || '';
            setInternalOnly(!!gallery.internalOnly);
            setName(iName);
            setDescription(iDesc);
            setItems(is);
            setShow(shown);
            setDisplayOrder(gallery.displayOrder);
        }
    }, [gallery, shown]);
    const handleClose = () => {
        handleGalleryChange({ id: gallery.id });
        setName('');
        setDescription('');
        setItems(undefined);
        setShow(false);
    };
    const handleShow = () => setShow(true);
    const handleGallerySelectorChange = (selectedItems: GalleryItem[]) => {
        const changed = changedItems(selectedItems);
        const g = {
            id: gallery?.id,
            name,
            description,
            items: changed,
            internalOnly,
            displayOrder,
        };
        handleGalleryChange && handleGalleryChange(g);
        setItems(changed);
    }
    const handleGalleryItemChange = ((item: GalleryItem) => {
        const changed = items?.map((i: GalleryItem) => {
            if (i.type === "file") {
                if (i.url === item.url) {
                    return item;
                }
            } else if (i?.image?.original === item?.image?.original) {
                return item;
            }
            return i;
        });
        const g = {
            id: gallery?.id,
            name,
            description,
            items: changed,
            internalOnly,
            displayOrder,
        };
        handleGalleryChange && handleGalleryChange(g);
        setItems(changed);
    });
    const handleNameChange = (event: ChangeEvent<any>) => {
        const changed: string = event.target.value || '';
        const g = {
            id: gallery?.id,
            name: changed,
            description,
            items,
            internalOnly,
            displayOrder,
        };
        handleGalleryChange && handleGalleryChange(g);
        setName(changed);
        handleIsValid({ valid: stringExists(changed), gallery });
    };
    const handleInternalOnlyChange = () => {
        const g = {
            id: gallery?.id,
            name,
            description: description,
            items,
            internalOnly: !internalOnly,
            displayOrder,
        };
        handleGalleryChange && handleGalleryChange(g);
        setInternalOnly(!internalOnly);
    };
    const handleDisplayOrderChange = (event: ChangeEvent<any>) => {
        const changed: number = parseInt((event.target.value || ''), 10);
        const g = {
            id: gallery?.id,
            name,
            description: description,
            items,
            internalOnly: internalOnly,
            displayOrder: changed,
        };
        handleGalleryChange && handleGalleryChange(g);
        setDisplayOrder(changed);
    };
    const handleDescriptionChange = (event: ChangeEvent<any>) => {
        const changed: string = event.target.value || '';
        const g = {
            id: gallery?.id,
            name,
            description: changed,
            items,
            internalOnly,
            displayOrder,
        };
        handleGalleryChange && handleGalleryChange(g);
        setDescription(changed);
        handleIsValid({ valid: stringExists(changed), gallery });
    };
    const handleRemoveItem = (item: GalleryItem) => {
        const gi = items ? [...items] : [];
        const changed = gi.filter(cgi => {
            if (cgi.type === "file") {
                return cgi.url !== item.url;
            } else {
                return cgi?.image?.original !== item?.image?.original;
            }
        });

        const g = {
            ...gallery,
            items: changed,
        };
        handleGalleryChange && handleGalleryChange(g);
        setItems(changed);
    };
    const stringExists = (value: string | undefined): boolean => {
        return !!value && !!value?.length;
    };

    return (
        <Card className="mt-4">
            <Card.Body>
                <Card.Title>
                    <h3>{name ? name : 'Gallery'}</h3></Card.Title>
                {show && <>
                    <Form.Group className="mt-4" id="GalleryNameControl">
                        <Form.Label>Name</Form.Label>
                        <Form.Control isInvalid={!stringExists(name)} onChange={handleNameChange} placeholder="Gallery Name" defaultValue={name} type="text" />
                    </Form.Group>
                    <Form.Group className="mt-4">
                        <Form.Label>{internalOnly ? 'DU Employees Only' : 'Visible to All'}</Form.Label>
                        <FormCheck type="switch" id={`internalOnly-${gallery.id}`} checked={internalOnly} label="" aria-label="is internalOnly" onChange={() => { handleInternalOnlyChange(); }} />
                    </Form.Group>
                    <Form.Group className="mt-4">
                        <Form.Label>Display Order</Form.Label>
                        <Form.Control type="number" id={`displayOrder-${gallery.id}`} defaultValue={displayOrder} onChange={handleDisplayOrderChange} />
                    </Form.Group>
                    <Form.Group className="mt-4" id="GalleryDescriptionControl">
                        <Form.Label>Description</Form.Label>
                        <Form.Control onChange={handleDescriptionChange} placeholder="Gallery Description" defaultValue={description} type="text" />
                    </Form.Group>
                    <Row xs={1} md={2} lg={3} xl={4} className="g-3 mt-3">
                        {
                            items && items.filter((i: GalleryItem) => i.selected).map((i: GalleryItem) => {
                                    switch (i.type) {
                                        case 'product':
                                            return <Col key={i?.product?.id} >
                                                <ProductItem handleGalleryItemChange={handleGalleryItemChange} handleRemoveItem={handleRemoveItem} item={i} />
                                            </Col>;
                                        case 'image':
                                            return <Col key={i?.image?.original}>
                                                <ImageItem handleGalleryItemChange={handleGalleryItemChange} handleRemoveItem={handleRemoveItem} item={i} />
                                            </Col>;
                                        case 'file':
                                            return <Col key={i?.url}>
                                                <FileItem handleGalleryItemChange={handleGalleryItemChange} handleRemoveItem={handleRemoveItem} item={i} />
                                            </Col>;
                                        default:
                                            return null;
                                    }
                            })
                        }
                    </Row>
                </>}
            </Card.Body>
            <Card.Footer>
                <Row className="justify-content-md-between">
                    <Col sm="auto"> <GallerySelector galleryItems={items} handleSave={handleGallerySelectorChange} /></Col>
                    <Col sm="auto">{!show && <Button variant="outline-secondary" onClick={handleShow}>
                        Edit Gallery
                    </Button>}
                        {show && <Button variant="outline-danger" onClick={handleClose}>
                            Remove {name ? name : 'Gallery'}  <FontAwesomeIcon icon="trash-alt" />
                        </Button>}</Col>
                </Row>
            </Card.Footer>
        </Card>
    );
}

export default Gallery;